import MiniProgramPage from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/subpackage/user/mine.vue'
wx.createPage(MiniProgramPage)